import React from 'react';
import { TeamMember } from '../types/pipeline';
import { Users } from 'lucide-react';
interface TeamMemberFilterProps {
  members: TeamMember[];
  selectedMemberId: string | null;
  onSelectMember: (id: string | null) => void;
}
export function TeamMemberFilter({
  members,
  selectedMemberId,
  onSelectMember
}: TeamMemberFilterProps) {
  return <div className="flex items-center space-x-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-321">
      <button onClick={() => onSelectMember(null)} className={`
          flex items-center px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap
          ${selectedMemberId === null ? 'bg-slate-900 text-white shadow-md ring-2 ring-slate-900 ring-offset-2' : 'bg-white text-slate-600 hover:bg-slate-50 border border-slate-200 shadow-sm'}
        `} data-id="element-322">
        <Users className="w-4 h-4 mr-2" data-id="element-323" />
        All Team Members
      </button>

      <div className="h-6 w-px bg-slate-200 mx-1" data-id="element-324" />

      {members.map(member => <button key={member.id} onClick={() => onSelectMember(member.id)} className={`
            flex items-center pl-1.5 pr-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap border
            ${selectedMemberId === member.id ? 'bg-white border-blue-500 text-blue-700 shadow-md ring-2 ring-blue-500 ring-offset-2' : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50 shadow-sm'}
          `} data-id="element-325">
          <img src={member.avatar} alt={member.name} className="w-7 h-7 rounded-full mr-2 object-cover border-2 border-white shadow-sm" data-id="element-326" />
          {member.name}
        </button>)}
    </div>;
}